import { render } from "./product.vue?vue&type=template&id=15f798d8&scoped=true"
import script from "./product.vue?vue&type=script&lang=js"
export * from "./product.vue?vue&type=script&lang=js"

import "./product.vue?vue&type=style&index=0&id=15f798d8&lang=less&scoped=true"

import exportComponent from "D:\\STD7159\\源码管理\\前端\\stgd.oa.ows.inernetweb\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15f798d8"]])

export default __exports__